import { SiteProviderProps } from '@sierralabs/site-ui';
import {
  servicePlugins,
  transitionConditionPlugins
} from '@sierralabs/workflow-ui';

import { CreateJiraIssuePlugin } from './services/CreateJiraIssuePlugin';
import { CreateTestRailCasePlugin } from './services/CreateTestRailCasePlugin';
import { TransitionEntityStatusFromJiraPlugin } from './services/TransitionEntityStatusFromJiraPlugin';
import { UpdateFieldFromJiraPlugin } from './services/UpdateFieldFromJiraPlugin';
import { UpdateJiraIssuePlugin } from './services/UpdateJiraIssuePlugin';
import { UpdateRelatedEntityStatusLegacyPlugin } from './services/UpdateRelatedEntityStatusLegacyPlugin';
import { CheckDependenciesLegacyPlugin } from './transition-conditions/CheckDependenciesLegacyPlugin';
import { SignaturePlugin } from './transition-conditions/SignaturePlugin';

// override default plugins
const filteredTransitionConditionPlugins = transitionConditionPlugins.filter(
  plugin => plugin.type !== SignaturePlugin.type
);

/**
 * Workflow plugins from QMS v1 to use in platform-stack
 * to allow using v1 entities and implementation.
 */
export const platformStackWorkflowPlugins: SiteProviderProps['workflowPlugins'] =
  {
    servicePlugins: [
      ...servicePlugins,
      CreateJiraIssuePlugin,
      TransitionEntityStatusFromJiraPlugin,
      UpdateFieldFromJiraPlugin,
      UpdateJiraIssuePlugin,
      UpdateRelatedEntityStatusLegacyPlugin,
      CreateTestRailCasePlugin
    ],
    transitionConditionPlugins: [
      ...filteredTransitionConditionPlugins,
      SignaturePlugin,
      CheckDependenciesLegacyPlugin
    ]
  };
